<template>
    <Transition v-if="isLoading" name="spinner">
        <div id="cover-spin">
            <span class="loader">
                <span>PROTO</span>
            </span>
        </div>
    </Transition>

    <v-form :name="formProps.formName"
            @keyup.enter="autoSave = false">
        <Tabs value="0"
              scrollable>

            <TabList>
                <Tab value="0">{{ __('Basic data') }}</Tab>
                <Tab value="1">{{ __('Changelog') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormSelect fieldName="provider_id"
                                    label="Provider"
                                    size="4"
                                    validation="required"
                                    :isFormDisabled="isFormDisabled"
                                    :options="select?.providers"
                                    :filter="(event) => onFilter(event, 'providers')"
                                    v-model:field="crud.provider_id" />

                        <FormSelect fieldName="category_id"
                                    label="Category"
                                    size="4"
                                    validation="required"
                                    :isFormDisabled="isFormDisabled"
                                    :options="select?.categories"
                                    :filter="(event) => onFilter(event, 'categories')"
                                    v-model:field="crud.category_id" />

                        <FormSelect fieldName="type_id"
                                    label="Type"
                                    size="4"
                                    :isFormDisabled="isFormDisabled"
                                    :options="select?.types"
                                    :filter="(event) => onFilter(event, 'types')"
                                    v-model:field="crud.type_id" />

                        <FormInputText fieldName="service_name"
                                       label="Service name"
                                       size="10"
                                       validation="required"
                                       :isFormDisabled="isFormDisabled"
                                       :isFocus="true"
                                       v-model:field="crud.service_name" />

                        <FormInputText fieldName="symbol"
                                       label="Symbol"
                                       size="2"
                                       validation="required"
                                       :isFormDisabled="isFormDisabled"
                                       :isFocus="true"
                                       v-model:field="crud.symbol" />

                        <FormInputText fieldName="lead_technology"
                                       label="Lead technology"
                                       size="12"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.lead_technology" />
                    </div>
                </TabPanel>
                <TabPanel v-if="crud.log"
                          value="1">
                    <ChangeLog :log="crud?.log" />
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <FormButtons :formProps="props.formProps"
                         :sourceForm="crud"
                         :validation="validation"
                         :buttonsVisibility="buttonsVisibility"
                         v-model:isFormDisabled="isFormDisabled"
                         v-model:autoSave="autoSave">
            </FormButtons>
        </div>
    </v-form>
</template>

<script setup>
import { ref, onMounted } from 'vue'

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import { validation, initForm } from '@pages/Helper/crud_utils.js'
import FormInputText from '@crud/FormInputText.vue'
import FormSelect from '@crud/FormSelect.vue'
import FormButtons from '@crud/FormButtons.vue'
import ChangeLog from '@crud/ChangeLog.vue'
import { onFilterService } from '@pages/Helper/crud_utils.js'
import { __ } from '@pages/Helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    formProps: Object,
})

const isLoading = ref(true);
const isFormDisabled = ref(false)
const autoSave = ref(false)
const buttonsVisibility = ref(null);
const options = ["providers", "categories", "types"];
const select = ref(null);


const crud = ref({})

// -----------------------------------------------------

onMounted(async () => {
    await initForm(props, crud, isLoading, options, select, buttonsVisibility)
})

// -----------------------------------------------------

const onFilter = async (event, option) => {
    await onFilterService(event, option, select, isLoading, crud, null);
}

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
